import { defineComponent as _defineComponent } from 'vue';
import { ref, reactive, getCurrentInstance, onMounted } from 'vue';
import SearchForm from '@blade-sxp/record-center/components/attendance-record/searchForm.vue';
import AttendanceTable from '@blade-sxp/record-center/components/attendance-record/attendanceTable.vue';
import { EAttendanceFormKey, EAttendanceSearchBtns, IColumnBtnKey, } from '@blade-sxp/record-center/interfaces/attendanceRecord';
import { getSearchFormConfig, getSearchBtnsConfig, getColumns, getPaginationConfig, getAttendanceStatusConfig, } from '@blade-sxp/record-center/config/attendanceRecordConfig';
import { useAttendanceRecordStore } from '@blade-sxp/record-center/store/attendanceStore';
import { exportFile } from '@blade-sxp/record-center/utils/index';
import moment from 'moment';
export default /*#__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const vm = getCurrentInstance()?.proxy;
        const store = useAttendanceRecordStore();
        const searchFormConfig = ref(getSearchFormConfig());
        const searchBtnsConfig = ref(getSearchBtnsConfig());
        const columns = ref(getColumns());
        const pagination = reactive(getPaginationConfig());
        const form = reactive({
            [EAttendanceFormKey.DATES]: [],
            [EAttendanceFormKey.STATUS]: '',
            [EAttendanceFormKey.KEYWORD]: '',
            [EAttendanceFormKey.LIB_IDS]: [],
        });
        const statusConfig = ref(getAttendanceStatusConfig());
        const tableData = ref([]);
        const changeSearch = (data) => {
            updateForm(data);
            initPagination(); // 切换了条件需要重置分页
            updateTable();
        };
        const handleClickBtn = ({ type, data }) => {
            switch (type) {
                case EAttendanceSearchBtns.SEARCH:
                    initPagination(); // 切换了条件需要重置分页
                    updateTable();
                    break;
                case EAttendanceSearchBtns.RESET:
                    initTable();
                    break;
                case EAttendanceSearchBtns.EXPORT:
                    exportTable();
                    break;
            }
        };
        onMounted(() => {
            initTable();
        });
        function updateForm(data) {
            form[EAttendanceFormKey.DATES] = data[EAttendanceFormKey.DATES];
            form[EAttendanceFormKey.STATUS] = data[EAttendanceFormKey.STATUS];
            form[EAttendanceFormKey.KEYWORD] = data[EAttendanceFormKey.KEYWORD];
            form[EAttendanceFormKey.LIB_IDS] = data[EAttendanceFormKey.LIB_IDS];
        }
        function initForm() {
            form[EAttendanceFormKey.DATES] = [moment().subtract(2, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
            form[EAttendanceFormKey.STATUS] = '';
            form[EAttendanceFormKey.KEYWORD] = '';
            form[EAttendanceFormKey.LIB_IDS] = [];
        }
        function initPagination() {
            const { page, size, total, sizes } = getPaginationConfig();
            pagination.page = page;
            pagination.size = size;
            pagination.sizes = sizes;
            pagination.total = total;
        }
        function initTable() {
            initForm();
            initPagination();
            updateTable();
        }
        async function updateTable() {
            try {
                const data = {
                    attendanceStatus: form[EAttendanceFormKey.STATUS],
                    dateStart: form[EAttendanceFormKey.DATES]?.[0],
                    dateEnd: form[EAttendanceFormKey.DATES]?.[1],
                    keyword: form[EAttendanceFormKey.KEYWORD],
                    libIds: form[EAttendanceFormKey.LIB_IDS],
                    page: pagination.page,
                    size: pagination.size,
                    pageOrderList: [],
                };
                const res = await store.getAttendanceList(data);
                tableData.value = res.list; //  赋值表格数据
                pagination.total = res?.total; // 重新赋值总条数
            }
            catch (e) {
                console.log(e);
            }
        }
        function clickColumnBtn({ key, data }) {
            switch (key) {
                case IColumnBtnKey.VIEW:
                    pageTo('recordCenter/attendanceDetail', {
                        id: data?.portraitId ?? '',
                        date: data?.attendanceDate,
                        jobNumber: data?.jobNumber,
                        department: data?.department,
                    });
                    break;
            }
        }
        function handleChangePage({ page, size }) {
            pagination.page = page;
            pagination.size = size;
            updateTable();
        }
        function pageTo(path, data) {
            vm?.$router.push({
                path: path,
                query: {
                    ...data,
                },
            });
        }
        async function exportTable() {
            try {
                const data = {
                    attendanceStatus: form[EAttendanceFormKey.STATUS],
                    dateEnd: form[EAttendanceFormKey.DATES]?.[1] ?? '',
                    dateStart: form[EAttendanceFormKey.DATES]?.[0] ?? '',
                    keyword: form[EAttendanceFormKey.KEYWORD],
                    libIds: form[EAttendanceFormKey.LIB_IDS],
                };
                const res = await store.exportAttendanceRecord(data);
                res && exportFile(res);
            }
            catch (e) {
                console.log(e);
            }
        }
        return { __sfc: true, vm, store, searchFormConfig, searchBtnsConfig, columns, pagination, form, statusConfig, tableData, changeSearch, handleClickBtn, updateForm, initForm, initPagination, initTable, updateTable, clickColumnBtn, handleChangePage, pageTo, exportTable, SearchForm, AttendanceTable };
    }
});
